import store from "@/redux/store";
import { beginFileViewerNavigation } from "@/redux/fileViewerSlice";

/** Capture intent before awaiting a lookup. Later opens and closes supersede it. */
export const beginViewerNavigation = () => {
  store.dispatch(beginFileViewerNavigation());
  return store.getState().fileViewerData.navigationEpoch;
};
export const isCurrentViewerNavigation = (intent: number) =>
  intent === store.getState().fileViewerData.navigationEpoch;
